module.exports = __webpack_public_path__ + "b417d7522b668ea2e437db84f49bc012.svg";